import { render, staticRenderFns } from "./DashboardSupperPlus.vue?vue&type=template&id=2e8caf38&scoped=true"
import script from "./DashboardSupperPlus.vue?vue&type=script&lang=js"
export * from "./DashboardSupperPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8caf38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e8caf38')) {
      api.createRecord('2e8caf38', component.options)
    } else {
      api.reload('2e8caf38', component.options)
    }
    module.hot.accept("./DashboardSupperPlus.vue?vue&type=template&id=2e8caf38&scoped=true", function () {
      api.rerender('2e8caf38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/DashboardSupperPlus.vue"
export default component.exports